import { Stack, Text } from "basis";
import { SvgInline } from "components/SvgInline/SvgInline";
import { ScreenProps } from "./types";

export const MaxTriesReached = ({
  errorFooter,
}: Pick<ScreenProps, "errorFooter">) => (
  <Stack gap="8">
    <SvgInline name="error-dog" width="236" />
    <Text textStyle="heading5" textStyle-sm="heading4">
      Unable to verify your identity
    </Text>
    <Text>
      You have exceeded the maximum attempts allowed. As a result, we’re unable
      to proceed with your request at this time.
    </Text>
    <Text>
      Please try again later or contact Latitude if the problem persists.
    </Text>
    {errorFooter}
  </Stack>
);
